module.exports = __webpack_public_path__ + "static/media/ba.05d089cb.png";